// Added by Sejune Oh on 2019-03-19
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React from 'react'
import { createStyles, withStyles, WithStyles, Theme, WithTheme } from '@material-ui/core'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Prime Elements
import { TableCell, Checkbox } from '@/components/_primes'
import { SelectableTablePartialProps } from '../../TableContainer'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface SelectableTableHeaderFCProps extends WithStyles<typeof styles>, WithTheme, SelectableTablePartialProps {}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const SelectableTableHeader = (props: SelectableTableHeaderFCProps) => {
    const { classes } = props

    return (
        <TableCell padding="checkbox" className={classes.CheckTableCell}>
            <Checkbox
                className={classes.CheckBoxWrapper}
                indeterminate={props.selectedNum > 0 && props.selectedNum < props.rowsNum}
                checked={props.isAllSelected}
                onChange={props.onSelectAllChange}
                onClick={props.onSelectAllClick}
                color={'primary'}
            />
        </TableCell>
    )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Styles
const styles = (theme: Theme) =>
    createStyles({
        CheckTableCell: {
            width: 24,
            boxSizing: 'content-box',
            padding: `0 0 0 ${theme.spacing()}px`,
        },
        CheckBoxWrapper: {
            width: 24,
            padding: 0,
            position: 'relative',
            '&>span:first-of-type': {
                justifyContent: 'flex-start',
                '&>input': {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    right: 0,
                    margin: 'auto',
                },
            },
        },
    })

export default withStyles(styles, { withTheme: true })(SelectableTableHeader)
